import { validation as ky } from "@/i18n/ky";
import { validation as ru } from "@/i18n/ru";
import { validation as uz } from "@/i18n/uz";
import { validation as az } from "@/i18n/az";
import { validation as tg } from "@/i18n/tg";

class Translator {
    ASSETS = {
        ky,
        ru,
        uz,
        az,
        tg,
    };

    constructor() {
        this.asset = this.ASSETS.ru;
    }

    set lang(lang) {
        const asset = this.ASSETS[lang];
        if (asset) {
            this.asset = asset;
        }
    }

    translate(path) {
        let data = this.asset;
        for (let l of path.split(".")) {
            data = data[l];
            if (!data) {
                return "";
            }
        }
        return data;
    }

    format(message, args) {
        return message.replace(/{\d+}/gm, function (match) {
            const i = Number(match.slice(1, match.length-1));
            return args[i] !== undefined ? args[i] : match;
        });
    }
}

export const translator = new Translator();

export default function (path, ...args) {
    if (args.length > 0) {
        return translator.format(translator.translate(path), args);
    }
    return translator.translate(path);
}